// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Pqt8","notes":"Notes_notes__2bXIq","note":"Notes_note__stFpg","markdown":"Notes_markdown__3ZqIi"};